import React, { FC, useState } from 'react';
import { PersonType, CoverType } from '../types';
import {
  faArrowRight,
  faArrowLeft,
  faCircle,
  faPlus,
  faMinus,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ageToGroup } from '../utils';
import covers from '../data/covers';

type Stage2Props = {
  page: number;
  persons: PersonType[];
  onPageChange: (value: number) => void;
  onPersonClick: (persons: PersonType[]) => void;
};

const Stage2: FC<Stage2Props> = ({
  page: propsPage,
  persons,
  onPageChange: handlePageChange,
  onPersonClick,
}) => {
  const [page, setPage] = useState(propsPage);

  const handleNextClick = () => {
    const nextPage = page === covers.length - 1 ? 0 : page + 1;
    setPage(nextPage);
    handlePageChange(nextPage);
  };

  const handlePrevClick = () => {
    const prevPage = page === 0 ? covers.length - 1 : page - 1;
    setPage(prevPage);
    handlePageChange(prevPage);
  };

  const handlePersonCoverClick = (person: PersonType) => {
    const index = persons.findIndex(({ id }) => id === person.id);
    person.covers[page] = !person.covers[page];
    const newPersons = [
      ...persons.slice(0, index),
      { ...person, covers: [...person.covers] },
      ...persons.slice(index + 1),
    ];
    onPersonClick(newPersons);
  };
  /*
  const handlePersonCoverClickQuick = (person: PersonType, pageId) => {
    const index = persons.findIndex(({ id }) => id === person.id);
    person.covers[page] = pageId;
    const newPersons = [
      ...persons.slice(0, index),
      { ...person, covers: [...person.covers] },
      ...persons.slice(index + 1),
    ];
    onPersonClick(newPersons);
  };
  */
  return (
    <div className="covers_section">
      <span className="subtitle">*יש לבחור את הכיסוי הרצוי עבור כל מבוטח</span>
      <div className="covers">
        {covers.map((cover) => (

          <div className="cover" key={cover.id}>
              <div className={page === cover.id ? ("title active") : ("title")} onClick={() => setPage(cover.id)}>
                  {cover.id + 1 + '. ' + cover.title}
                  <FontAwesomeIcon
                    icon={page === cover.id ? faMinus : faPlus}
                    size="sm"
                  />
                  {/*
                  <div className="quick">
                    <span>הוסף כיסוי:</span>
                    <div className="quick_buttons">
                      {persons.map((person) => (
                        <div className={person.covers[page] ? "add_cover active" : "add_cover"} key={person.id} onClick={() => handlePersonCoverClick(person)}>
                          <span className="name">{person.name}</span>
                          <FontAwesomeIcon
                            icon={person.covers[page] ? faCheck : faPlus}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  */}
              </div>
             
              {page === cover.id ? (
                <Cover
                  cover={covers[page]}
                  onNextClick={handleNextClick}
                  onPrevClick={handlePrevClick}
              />
              ) : null}
              {page === cover.id ? (
              <div className="covers_select">
                <p className="text-2xl font-bold p-2 leading-none">
                  הוסף כיסוי זה עבור:
                </p>
                <div className="con">
                  {persons.map((person) => (
                    <div
                      className="m-2 add"
                      key={person.id}
                      onClick={() => handlePersonCoverClick(person)}
                    >
                      <div className="text-2xl leading-none">
                        <span className="name">{person.name}</span>
                        <span className="text-sm  text-gray-800 age">{person.age}</span>
                        <FontAwesomeIcon
                          className={person.covers[page] ? 'on' : ''}
                          icon={person.covers[page] ? faCheck : faPlus}
                          size="sm"
                        />
                      </div>
                      <div>
                        <span className="text-sm">
                          {covers[page].prices[ageToGroup(person.age)]} ₪ לחודש
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              ) : null }
          </div>
        ))}
      </div>
    </div>
  );
};

type CoverProps = {
  cover: CoverType;
  onPrevClick: () => void;
  onNextClick: () => void;
};

const Cover: FC<CoverProps> = ({
  cover,
  onNextClick: handleNextClick,
  onPrevClick: handlePrevClick,
}) => {
  return (
    <>
      <div className="content p-2 flex">
        {/*
        <div>
          <button className="h-full w-16" onClick={handlePrevClick}>
            <FontAwesomeIcon icon={faArrowRight} size="2x" color="#FCB831" />
          </button>
        </div>
        */}
          {/*<p>
            <span className="font-bold text-2xl">{cover.title}</span>
          </p>*/}

          <p>{cover.description}</p>
        {/*
        <div>
          <button className="h-full w-16" onClick={handleNextClick}>
            <FontAwesomeIcon icon={faArrowLeft} size="2x" color="#FCB831" />
          </button>
        </div>
        */}
      </div>
    </>
  );
};

export default Stage2;
